import { supabase } from '../supabaseClient';

/* Accès aux données « affaire_lignes ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function deleteDealLines(toDelete) {
  return supabase.from('affaire_lignes').delete().in('id', toDelete);
}

export function upsertDealLines(dealId, dealLineToRow, lignes) {
  return supabase.from('affaire_lignes').upsert(lignes.map((l, i) => dealLineToRow(l, dealId, i)));
}

export function fetchDealLines() {
  return supabase.from('affaire_lignes').select('*').order('ordre', { ascending: true });
}

export function updateDealLine(id, patch) {
  return supabase.from('affaire_lignes').update(patch).eq('id', id);
}
